module.exports = __webpack_public_path__ + "media/post-listing-block-4-overlay@2x.e6d42671.webp";